module.exports = __webpack_public_path__ + "grootstatic/media/logo.29b87d72.svg";